import React from 'react';
import ErrorPage from '../ztn/ErrorPage';
import * as Sentry from '@sentry/nextjs';
import Router from 'next/router';

export default class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };

    // Clear error state on router events (e.g. back button)
    Router.events.on('routeChangeStart', () => {
      this.state.hasError && this.setState({ hasError: false })
    })
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.error('Error: ', error);
    console.log('Error Info', errorInfo);
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      const error = this.state.error;

      return (
        <ErrorPage
          title={error.response?.status}
          details={error.response && error.request && <>
            <p>Endpoint: {error.request.responseURL}</p>
            <p>Response Text: {error.response.data.Error}</p>
          </>}
        >
          {error.toString()}
        </ErrorPage>
      );
    }

    return this.props.children;
  }
}
